import svgIconsAndStyles from './icons';
export var getStyle = function (partName) {
    return function (args) {
        var props = args.props;
        var maybeIconSpec = svgIconsAndStyles[props.name];
        var maybeIconStyles = maybeIconSpec && maybeIconSpec.styles;
        if (maybeIconStyles && maybeIconStyles[partName]) {
            return maybeIconStyles[partName](args);
        }
        return undefined;
    };
};
export default svgIconsAndStyles;
